module.exports = __webpack_public_path__ + "static/img/junyi6.bffd776.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/junyi6.png
// module id = oELN
// module chunks = 1